import { useState } from "react";

import axiosInstance from "../../../../url/createAxios";

const CardRetryLogic = (changeModalPage, setReservation) => {
  const [pageMessage, setPageMessage] = useState(
    "There was a problem with card registration!"
  );

  const instance = axiosInstance();
  const pxpCallback = async () => {
    setTimeout(async () => {
      const { data } = await instance.post(`/pxp/callback`, {
        withCredentials: true,
        callbackStatus: "success",
      });
      if (data === "success") {
        setReservation((prevState) => {
          return { ...prevState, CreditCard: true };
        });
        changeModalPage((prevState) => {
          return { ...prevState, page: "CardConfirmation" };
        });
      } else {
        setPageMessage(
          "We could not add the credit card to your reservation. Please try again later!"
        );
      }
    }, 3100);
  };

  return { pxpCallback, pageMessage };
};

export default CardRetryLogic;
